export default "__VITE_PUBLIC_ASSET__8ebfd09b__"